import { Container, Title, Text, Stack } from '@mantine/core';

export function PrivacyPolicy() {
  return (
    <Container size="md" py="xl" mt={20} sx={{ minHeight: 'calc(100vh - 60px)' }}>
      <Stack spacing="lg">
        <Title order={1}>Privacy Policy</Title>
        
        <Text>Last updated: March 2024</Text>

        <Stack spacing="md">
          <Title order={2}>1. Information We Collect</Title>
          <Text>
            We collect information that you provide directly to us, including your name, email address,
            and any other information you choose to provide through the Report Management System.
          </Text>

          <Title order={2}>2. How We Use Your Information</Title>
          <Text>
            We use the information we collect to provide and maintain the Report Management System,
            to communicate with you about your account, and to improve our services.
          </Text>

          <Title order={2}>3. Information Sharing</Title>
          <Text>
            We do not share your personal information with third parties except as required to provide
            our services or as required by law. We may share aggregated, non-personal information for
            analytical purposes.
          </Text>

          <Title order={2}>4. Data Security</Title>
          <Text>
            We implement appropriate technical and organizational measures to protect your personal
            information against unauthorized access, alteration, disclosure, or destruction.
          </Text>

          <Title order={2}>5. Your Rights</Title>
          <Text>
            You have the right to access, correct, or delete your personal information. You may also
            have the right to restrict or object to certain processing of your information.
          </Text>

          <Title order={2}>6. Contact Us</Title>
          <Text>
            If you have any questions about this Privacy Policy or our privacy practices, please
            contact our Data Protection Officer at privacy@reportmanagementsystem.com
          </Text>
        </Stack>
      </Stack>
    </Container>
  );
} 
